const TagSkeleton = () => {
  return <div className="h-6 w-14 animate-pulse rounded-md bg-gray-200 px-2 py-1" data-sentry-component="TagSkeleton" data-sentry-source-file="index.tsx" />;
};
export default TagSkeleton;